export const isMicroApp = !!window.__POWERED_BY_QIANKUN__
export const isDev = process.env.NODE_ENV !== 'production'
export const projectId = 'entry'
